<template>
  <v-layout column ref="dropzone">
    <v-flex xs12>
      <v-hover>
        <v-card slot-scope="{hover}" flat :class="round ? 'round' : ''">
          <v-img
            class="grey lighten-3"
            cover
            :src="status.loading ? '' : (manual ? innerUrl : url) || ''"
            :width="width"
            :height="height"
            @click="onFocusLogo"
          >
            <v-expand-transition>
              <v-layout
                v-if="hover && !status.loading"
                class="grey lighten-1 transition-fast-in-fast-out darken-2 v-card--reveal white--text text-xs-center"
                column
                fill-height
                align-center
                justify-center
                style="opacity: 0.9; cursor: pointer;"
                @click.stop="onFocusLogo"
              >
                <v-icon medium>add_a_photo</v-icon>
                <div class="white--text caption mt-1 px-1">
                  {{
                    determineDragAndDropCapable
                      ? 'Drag and drop or click to replace'
                      : 'Click to replace'
                  }}
                </div>
              </v-layout>
              <v-layout
                column
                fill-height
                align-center
                justify-center
                white
                style="opacity: 0.66;"
                v-if="status.loading"
              >
                <v-progress-circular
                  size="64"
                  indeterminate
                  class="mb-2"
                  color="primary"
                ></v-progress-circular>
                <br />
                <small class="mb-2">Uploading image</small>
              </v-layout>
            </v-expand-transition>
          </v-img>
        </v-card>
      </v-hover>
      <v-alert
        key="message"
        v-if="status.message && !manual"
        :value="true"
        class="text-xs-center mt-4"
        :color="status.error ? 'error' : 'success'"
        :icon="status.error ? 'warning' : 'check_circle'"
        outline
      >
        <!-- {{ $language.registration["Image uploaded successfully"] }} -->
        {{ status.message }}
      </v-alert>
    </v-flex>
    <!-- <v-flex xs12 mt-3 text-xs-center>
      <v-btn
        fab
        color="success"
        depressed
        @click="upload"
        v-if="uploadReady"
        >
        <v-icon v-if="!status.loading" color="white">
          fas fa-check
        </v-icon>
        <span v-if="status.loading">0%</span>
      </v-btn>
    </v-flex> -->
    <input
      ref="fileInputLogo"
      type="file"
      name="logo"
      style="display: none !important;"
      :accept="accept || '.png, .jpg'"
      @change="onFileChangeLogo"
    />
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
// import Pica from 'pica'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['url', 'width', 'height', 'size', 'accept', 'round', 'manual'],
  data () {
    return {
      customStorageUrl: '',
      innerUrl: '',
      file: null,
      dropzoneCapable: false,
      uploadReady: false,
      status: {
        loading: false,
        error: false,
        message: ''
      }
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser', 'categories'])
  },
  methods: {
    onFocusLogo () {
      this.$refs.fileInputLogo.click()
    },

    determineDragAndDropCapable () {
      /*
        Create a test element to see if certain events
        are present that let us do drag and drop.
      */
      var div = document.createElement('div')

      /*
        Check to see if the `draggable` event is in the element
        or the `ondragstart` and `ondrop` events are in the element. If
        they are, then we have what we need for dragging and dropping files.

        We also check to see if the window has `FormData`.
      */
      return ('draggable' in div || ('ondragstart' in div && 'ondrop' in div)) in window
    },

    setCustomStorageUrl (url) {
      this.customStorageUrl = url
      console.log(this.customStorageUrl)
    },

    hasImage () {
      return !!this.file
    },

    async upload () {
      if (this.manual) {
        return new Promise(async (resolve, reject) => {
          try {
            let uploadedImage = await fb.storage.ref(this.customStorageUrl).put(this.file)
            let imageSrc = await uploadedImage.ref.getDownloadURL()
            resolve(imageSrc)
          } catch (error) {
            reject(error)
          }
        })
      } else {
        this.status.loading = true
        this.status.error = false
        this.status.message = ''

        try {
          let response = await fb.storage
            .ref(`images/${this.currentUser.uid}/profile_photo`)
            .put(this.file)
          let link = await response.ref.getDownloadURL()

          var updates = {}
          updates[`user/${this.currentUser.uid}/profile/photoURL`] = link
          await fb.database.ref().update(updates)

          this.status.loading = false
          this.status.error = false
          this.status.message = 'Upload successful'
          this.uploadReady = false
        } catch (error) {
          let message = ''
          if (error.response) {
            message = error.response.data.message
          } else if (error.request) {
            message =
              'No response received from the server. If the problem persists contact the site administrator (' +
              error.message +
              ')'
          } else {
            message = error.message
          }
          this.status.loading = false
          this.status.error = true
          this.status.message = message
        }
      }
    }

    // async onFileChangeLogo ($event) {
    //   let file = $event.target.files || $event.dataTransfer.files
    //   file = file[0]
    //   if (file) {
    //     if (file.type === 'image/jpeg' || file.type === 'image/png') {
    //       this.file = file
    //       const pica = require('pica')()
    //       let canvas = document.createElement("canvas");
    //
    //       pica.resize(this.file, canvas, {
    //         unsharpAmount: 80,
    //         unsharpRadius: 0.6,
    //         unsharpThreshold: 2
    //       })
    //       .then(result => console.log('resize done!'))
    //
    //       if (this.manual) {
    //         this.innerUrl = window.URL.createObjectURL(file)
    //       } else {
    //         // this.upload()
    //       }
    //     } else {
    //       this.status.loading = false
    //       this.status.error = true
    //       this.status.message = 'File must be an image.'
    //     }
    //   } else {
    //     this.status.loading = false
    //     this.status.error = true
    //     this.status.message = 'Failed to select image.'
    //   }
    // }
  },

  watch: {
    url () {
      if (this.manual) {
        this.innerUrl = this.url
      }
    }
  },

  mounted () {
    if (this.determineDragAndDropCapable()) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(
        function (evt) {
          /*
          For each event add an event listener that prevents the default action
          (opening the file in the browser) and stop the propagation of the event (so
          no other elements open the file in the browser)
        */
          this.$refs.dropzone.addEventListener(
            evt,
            function (e) {
              e.preventDefault()
              e.stopPropagation()
            },
            false
          )
        }.bind(this)
      )

      /*
        Add an event listener for drop to the dropzone
      */
      this.$refs.dropzone.addEventListener(
        'drop',
        function (e) {
          this.onFileChangeLogo(e)
        }.bind(this)
      )
    }
  }
}
</script>

<style scoped>
.round {
  border-radius: 50% !important;
  overflow: hidden !important;
}
</style>
